export default abstract class DatetimeValue {
  abstract create(datetime?: string, timezone?: string): DatetimeValue;

  abstract toString(): string;

  abstract toJSON(): string;
}
